import { render, staticRenderFns } from "./RightToBuyYN.vue?vue&type=template&id=7c7132ae"
import script from "./RightToBuyYN.vue?vue&type=script&lang=js"
export * from "./RightToBuyYN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports